// Root application component (Task 13 / 14.1).
//
// Renders the offline/online banner over the whole app (Req 29.7/29.8), a
// professional top app bar, and the AuthGate, which owns Google Sign-In
// session handling and routing to Role Selection, registration, dashboards,
// the admin panel, notifications, and the profile view.
import { useState } from "react";
import { OfflineBanner } from "./components/OfflineBanner";
import { AuthGate } from "./features/auth/AuthGate";
// --- TEMPORARY DEMO (safe to remove): import + the `demo` branch below ---
import { DemoApp } from "./demo/DemoApp";

function Brand({ subtitle }: { subtitle?: string }): JSX.Element {
  return (
    <span className="sb-brand">
      <img className="sb-logo" src="/sharebite-logo.png" alt="ShareBite" />
      {subtitle && <span className="sb-brand__sub">{subtitle}</span>}
    </span>
  );
}

export default function App() {
  const [demo, setDemo] = useState(false);

  if (demo) {
    return (
      <div className="sb-app">
        <OfflineBanner />
        <DemoApp onExit={() => setDemo(false)} brand={<Brand subtitle="Demo Mode" />} />
      </div>
    );
  }

  return (
    <div className="sb-app">
      <OfflineBanner />
      <header className="sb-appbar">
        <div className="sb-appbar__inner">
          <Brand subtitle="Surplus food, shared with purpose" />
          <span className="sb-spacer" />
          {/* --- TEMPORARY DEMO entry (safe to remove) --- */}
          <button
            type="button"
            className="sb-btn sb-btn--secondary"
            onClick={() => setDemo(true)}
          >
            View interactive demo
          </button>
        </div>
      </header>
      <AuthGate />
    </div>
  );
}
